import serverName from "./serverName"

const hostUrl = "/"
const pre = serverName
let imgPrefix = ''
if (pre != '') {
    imgPrefix = hostUrl + pre + 'api/portal-affairs/document/get/' //图片前缀
} else {
    imgPrefix = 'api/portal-affairs/document/get/' //图片前缀
}


export default imgPrefix 